import cookies from './cookie';
import { getEnv } from './env';
import storage from './storage';

/**
  * @description 在项目入口, 尽可能早的初始化六翼 SDK, 以保证收集到的请求错误等信息最完整。
  * - 一定要在主逻辑代码之前, 以保证请求拦截逻辑生效。【不要在 MonitorJS 初始化前，把fetch初始化了，会无法拦截请求的】
  * @refer http://wiki.zhonganonline.com/pages/viewpage.action?pageId=79276059
  * @todo 1、调用链接入 2、sourceMap上传
*/
export default function initSeraphMonitorSDK() {
  const accountId = storage.get('accountId');
  // 初始化monitor监控
  (window as any).MonitorJS({
    seraphId: 'e7b0ffffffcf240f',
    H5Version: '1.0.21', // <你的应用版本号>, 不需要区分版本可以填 1.0.0
    env: getEnv(),
    extendsInfo: {
      who: 'test',
    },
    // getDynamic为动态扩展字段，如需配置动态扩展字段，需以getDynamic为属性名称，函数体里面放置动态返回的对象
    getDynamic() {
      return {
        ZAHLWYY_channelSource: cookies.get('channelSource') || '',
        ZAHLWYY_channelResourceCode: cookies.get('channelResourceCode') || '',
        ZAHLWYY_userId: cookies.get('maskusId') || '',
        ZAHLWYY_accountId: cookies.get('maskActId') || '',
      };
    },
    ignoreUrls: [/.+?hot-update.+/],
    trace: {
      serviceName: 'za-asclepius-patient-h5',
      serviceId: '5533',
      companyId: '695001',
      env: getEnv(),
    },
  });

  (window as any)?.__SERAPH_HAS_MONITOR__?.setUser?.({ userId: accountId });
}
